import React, { Suspense, lazy } from "react";
import Spinner from "./ui/spinner";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";

const AboutHero = lazy(() => import("./pages/for_About_us/about-hero"));
const MissionVision = lazy(() => import("./pages/for_About_us/mission-vision"));
const OurFounders = lazy(() => import("./pages/for_About_us/our-founders"));
const Footer = lazy(() => import("./footer"));

export const AboutUs = () => {
  const seo = SEO_PAGES.about;
  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "About Us", path: "/about-us" },
          ]),
        ]}
      />
    <div id="about-us">
      <main className="flex flex-col">
        <Suspense fallback={<Spinner />}>
          <AboutHero />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <MissionVision />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <OurFounders />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <Footer />
        </Suspense>
      </main>
    </div>
    </>
  );
};
